import _mixin from "../_mixin";

export default {
  name: "SVersionContract",
  cnName: "契约类",
  type: "activity_version",
  preview: "",
  // 属性相关
  props: {
    activityId: "QAGEWNR7GEFC2VTGYSU4263Y2Y",
    defaultBg: {
      src: "https://rescdn-crash.ssjj.cn/website/2025/09/15/c58ac7a95f265e81e01c0c8246e92b6c.jpg",
      style: {
        width: "1920px",
        height: "916px"
      }
    },
    boxSize: '1220px 540px',
    boxPosition: [
      {
        top: "330px",
        left: "350px"
      }
    ],
    contractOne: "https://rescdn.ssjj.cn/website/2025/09/17/a1da9ff0ea579bbff177f056a0ee6e7b.png",
    boxStyle: '{}',
    itemStyle: '{"display": "flex", "flex-direction": "column", "justify-content": "space-between"}',
    itemSize: '393px 520px',
    btnList: [
      {
        name: "待签订按钮",
        src: "https://rescdn.ssjj.cn/website/2025/09/18/70fdfd7b4b411751d6cbee8abac052b6.png"
      },
      {
        name: "立即领取按钮",
        src: "https://rescdn.ssjj.cn/website/2025/09/18/d301c6434c355ab3e88de9fa190f65d8.png"
      },
      {
        name: "已领取按钮",
        src: "https://rescdn.ssjj.cn/website/2025/09/18/aefe182dd83dc37a453d3cdc3cdab1e1.png"
      },
      {
        name: "已契约按钮",
        src: "https://rescdn.ssjj.cn/website/2025/09/19/98af32050e5efa14b849fc26757247c9.png"
      }
    ],
    imgStyle: '393px 437px',
    btnStyle: '153px 52px'
  },
  propsDesc: [
    {
      target: "activityId",
      label: "活动Id"
    },
    {
      target: "defaultBg",
      label: "底图",
      formType: "image"
    },
    {
      target: "contractOne",
      label: "契约占位图",
      formType: "image"
    },
    {
      target: "boxSize",
      label: "容器尺寸",
      formType: "size"
    },
    {
      target: "boxPosition",
      label: "容器位置",
      formType: "list",
      listConfig: [
        { target: "top", title: "上" },
        { target: "left", title: "左" }
      ]
    },
    {
      target: "boxStyle",
      label: "容器样式",
      formType: "textarea"
    },
    {
      target: "itemSize",
      label: "子容器尺寸",
      formType: "size"
    },
    {
      target: "itemStyle",
      label: "契约子容器样式",
      formType: "textarea"
    },
    {
      target: "btnList",
      label: "按钮列表",
      formType: "list",
      listConfig: [
        { target: "name", title: "按钮名称" },
        { target: "src", title: "按钮图片" }
      ]
    },
    {
      target: "imgStyle",
      label: "图片尺寸",
      formType: 'size'
    },
    {
      target: "btnStyle",
      label: "按钮尺寸",
      formType: 'size'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [..._mixin.stylesDesc],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [..._mixin.eventsDesc],

  methods: [..._mixin.methods]
};
